exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.obj-resources-table .file-type span[data-v-321d230a] {\n    font-size: 0.75rem;\n    color: #a3a3a3;\n    white-space: nowrap;\n    text-align: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-321d230a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/HkepDisplaySize.vue
// module id = v1j8
// module chunks = 2 3 4 5 6